import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { AuthService } from "../services/auth.service";
import { catchError, switchMap } from "rxjs/operators";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private authService: AuthService
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes('login')) return next.handle(req)

        const headers = {
            Authorization: `Bearer ${this.authService.token}`,
            'Content-Type': 'application/json'
        }

        const reqClone = req.clone({ setHeaders: headers })

        return next.handle(reqClone).pipe(
            catchError((err: HttpErrorResponse) => {
                if (err.status === 403 || err.status === 401) {
                    return this.manageTokenError(req, next, headers)
                } else return throwError(err)
            })
        )
    }

    private manageTokenError(req: HttpRequest<any>, next: HttpHandler, headers: {[key: string]: string}): Observable<HttpEvent<any>> {
        return this.authService.generateToken().pipe(
            switchMap(() => {
                const newReq = req.clone({ 
                    setHeaders: {
                        ...headers,
                        Authorization: `Bearer ${this.authService.token}`
                    } 
                })

                return next.handle(newReq)
            }),
            catchError(() => throwError(new Error('No se pudo generar el token')))
        )
    }
}